const dictionary: { [key: string]: string } = {
    'bb8d1bb424df406da33089cb818880b1': 'at',
    '194ab160f89746ba87bc771fb1d321bf': 'at',
    '1d953adb4a7042e785d29b4b56f4bfb2': 'be',
    'b7d2554b0ce847cd82f3ac9bd1c0dfca': 'be',
    'ce9e24958d2144bebfdacd2292bc61f0': 'ch',
    '8a243080f92e4c719546314b577cf82b': 'ch',
    'ad410de417314f6b812be7769c45fe4b': 'de',
    'f09d6c7175824e47ab6ce1d28554f097': 'de',
    'd289772971654e5e981e793b0a745639': 'dk',
    '690218b36ac043be99c3d0d4048088f3': 'dk',
    'c8b840e7c54b4e0bb6ecb1b8fb19fd46': 'fi',
    '3ebf3ca6e2ce42b680f6c753aa1c5406': 'fi',
    '4bacb12cb0bf44759ba6c3beb3fb3d58': 'fr',
    'fdf6854d39cc4a89b5d0e3ae6c446a05': 'fr',
    '9a1c4afc38ed4c1d9bcd942ae6bd9e28': 'se',
    '7a206d9c3297413d8d7727196fd228e3': 'se',
    '2a254cc2326a49108e8263b4916d1622': 'no',
    '43b33c93eb6c4e2a905942bc9ce75206': 'no',
    '1c4eadf9c97f433cb237d52fd9b08b9d': 'nl',
    '3fc0118350c84641a6cccde48facd567': 'nl',
    '2625b67351684e3086cf8d5eabcf3f55': 'uk',
    '067065aa80e64dd3a2db2c5ed1e8afc3': 'uk',
    '632eb93c863e4f94b2c7eaea341fa51a': 'uk',
}

export const getCountryCode = (salesChannelId: string): string => dictionary[salesChannelId];
